// import React from 'react';

// function RVWSStatus() {
//   // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=92d3b3ea-4315-41b6-ae1e-139948f40e90&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
//   const powerBiUrl = process.env.REACT_APP_RVWS_Status;

//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    
//   );
// }

// export default  RVWSStatus;



import React, { useState, useEffect,useRef } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Select, { components } from 'react-select';
import { showToast } from '../toastUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import html2pdf from 'html2pdf.js';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';
import * as XLSX from 'xlsx';

function RVWSStatus() {
  const contentRef = useRef();
  
  // const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=31512037-cdbc-482d-b22a-30e9a887383f&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
  //not used
  const columnOptions1 = [
    'Sno', 'RVW_Submitted_by', 'Proj_Number', 'Reason_for_RVW', 'VWR_NO',
    'Description', 'Status', 'Work_Description', 'Nett_Add_Omit', 'Bal_of_Contingency',
    'Name_First_Approval', 'Date_First_Approval', 'Outcome_First_Approval', 'Comments_First_Approval', 'Name_Second_Approval',
    'Date_Second_Approval','Outcome_Second_Approval', 'Comments_Second_Approval', 'Name_Third_Approval', 'Date_Third_Approval',
    'Outcome_Third_Approval', 'Comments_Third_Approval', 'Star_Rate_Items', 'Star_Rate_Status', 'Type_of_Request', 'Approval_in_Principle_Status',
    'Reason_Users_Requirement','RVW_Document_Link','Remarks'
  ];

  const columnOptions = [
    'Sno','SC_Number','Proj_Name','Tender_Ref_No','RVW_No','RVW_Type','Description', 'Work_Description', 
    'Reason_for_RVW', 'Nett_Add_Omit', 'Bal_of_Contingency', 'Star_Rate_Items', 'Star_Rate_Status',
    'Submission_Status','Submission_Link', 'RVW_Submitted_by', 'Review_Status', 'Review_Link',
    'RVW_Document_Link', 'Name_First_Approval', 'Date_First_Approval', 'Outcome_First_Approval', 
    'Comments_First_Approval', 'Name_Second_Approval','Date_Second_Approval','Outcome_Second_Approval', 
    'Comments_Second_Approval', 'Name_Third_Approval', 'Date_Third_Approval','Outcome_Third_Approval', 
    'Comments_Third_Approval','Name_Fourth_Approval', 'Date_Fourth_Approval', 'Outcome_Fourth_Approval', 
    'Comments_Fourth_Approval','Name_Fifth_Approval', 'Date_Fifth_Approval', 'Outcome_Fifth_Approval', 
    'Comments_Fifth_Approval','Remarks'
  ];

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';  
  const getUserAccess = userDetails ? userDetails.access_level : '';
  //const getUserAccess = 'project_admin'; 
  const [rows, setRows] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(columnOptions);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [sortDirection, setSortDirection] = useState('asc'); 

  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);

  let user_company = JSON.parse(localStorage.getItem("userCompany"));
  let nus_sts = (user_company === "NUS") ? 1 : 0;
  let p_access = selectedProjectDetail.Proj_Access.proj_access_level;
  let p_roles = selectedProjectDetail.Proj_Access.proj_role.join(", ");
  let proj_name=selectedProjectDetail?.projectName;

  let qs_params = `nususer=${nus_sts}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;
    
      const handleSort = () => {
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);
    
        const sortedRows = [...rows].sort((a, b) => {
          const projNameA = a.RVW_Submitted_by.toLowerCase();
          const projNameB = b.RVW_Submitted_by.toLowerCase();
    
          if (newSortDirection === 'asc') {
            return projNameA.localeCompare(projNameB); // Ascending order
          } else {
            return projNameB.localeCompare(projNameA); // Descending order
          }
        });
    
        setRows(sortedRows);
      };

  // const fetchWBSData = () => {
  //   setIsLoading(true)
  //   const requestOptions = {
  //     method: 'GET',
  //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //   };

  //   queuedApiFetch('/project/get_rvws_status_account', requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //         setRows(data.data);
  //         setIsLoading(false)
  //       }
  //     })
  //     .catch((error) => console.error('Error fetching data:', error))
  //     .finally(() => setIsLoading(false));
  // };

  const fetchWBSData = async () => {
    setIsLoading(true);
  
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
  
    try {
      const response = await queuedApiFetch(`/project/get_rvws_status_account`, requestOptions);
      const data = await response;
  
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setRows(data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchWBSData();
  }, []);

  // const handleExport = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Projects');    
  //   worksheet.columns = selectedColumns.map(column => {
  //     const header = column.replace(/_/g, ' ').toUpperCase();
  //     return { header, key: column };
  //   });    
  //   rows.forEach(row => {
  //     const rowData = {};
  
  //     selectedColumns.forEach(column => {
  //       let value = row[column] || '';        
  //       const dateValue = new Date(value);                
  //       if (value && !isNaN(dateValue.getTime()) && typeof value === 'string' && value.trim() !== '' && /\d{4}-\d{2}-\d{2}/.test(value)) {          
  //         rowData[column] = dateValue.toLocaleDateString('en-US');
  //       } else {          
  //         rowData[column] = value;
  //       }
  //     });      
  //     worksheet.addRow(rowData);
  //   });    
  //   workbook.xlsx.writeBuffer().then(buffer => {
  //     saveAs(new Blob([buffer]), 'RVWSStatusAccountList.xlsx');
  //   });
  // };  
  

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Export');    
  
    const orderedColumns = selectedColumns.includes('Sno')
      ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
      : selectedColumns;
  
    worksheet.columns = orderedColumns.map(column => {
      const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
      return { header, key: column };
    });
  
    // Initialize auto-increment counter for "Sno"
    let snoCounter = 1;
  
    rows.forEach(row => {
      const rowData = {};
  
      orderedColumns.forEach(column => {
        if (column === 'Sno') {
          // Set auto-incremented value for "Sno"
          rowData[column] = snoCounter++;
        } else {
          let value = row[column] || '';
          const dateValue = new Date(value);
  
          if (
            value && !isNaN(dateValue.getTime()) &&
            typeof value === 'string' && value.trim() !== '' &&
            /\d{4}-\d{2}-\d{2}/.test(value)
          ) {
            // Format dates to dd-mm-yyyy
            const day = String(dateValue.getDate()).padStart(2, '0');
            const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = dateValue.getFullYear();
            rowData[column] = `${day}-${month}-${year}`;
          } else if (
            ['Nett_Add_Omit', 'Bal_of_Contingency'].includes(column) &&
            typeof value === 'number'
          ) {
            // Format currency columns as $XXX,XXX.00
            rowData[column] = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          } else {
            // Other columns
            rowData[column] = value;
          }
        }
      });
  
      worksheet.addRow(rowData);
    });
  
    // Export to Excel file
    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer]), 'RVWSStatusAccountList.xlsx');
    });
  };

  const labelMapping1 = {
    Sno: 'S.No',
    RVW_Submitted_by: 'RVW Submitted by (Requester)',
    Proj_Number: 'Project Number (Tender_Ref_No)',
    Reason_for_RVW: 'Reason for RVW',
    VWR_NO: 'VWR NO',
    Description: 'Description',
    Status: 'Status',
    Work_Description: 'Work Description',
    Nett_Add_Omit: 'Nett Add/(Omit)',
    Bal_of_Contingency: 'Balance of Contingency',
    Name_First_Approval: 'Name First Approval',
    Date_First_Approval: 'Date First Approval',
    Outcome_First_Approval: 'Outcome First Approval',
    Comments_First_Approval: 'Comments First Approval',
    Name_Second_Approval: 'Name Second Approval',
    Date_Second_Approval: 'Date Second Approval',
    Outcome_Second_Approval: 'Outcome Second Approval',
    Comments_Second_Approval: 'Comments Second Approval',
    Name_Third_Approval: 'Name Third Approval',
    Date_Third_Approval: 'Date Third Approval',
    Outcome_Third_Approval: 'Outcome Third Approval',
    Comments_Third_Approval: 'Comments Third Approval',
    Star_Rate_Items: 'Star Rate Items',
    Star_Rate_Status: 'Star Rate Status',
    Type_of_Request: 'Type of Request',
    Approval_in_Principle_Status: 'Approval in Principle Status',
    Reason_Users_Requirement: 'Reason for User’s Requirement or Others',
    RVW_Document_Link: 'RVW/Document Link',
    Remarks:'Remarks',
};

 const labelMapping = {
    Sno: 'S.No',
    SC_Number: 'SC Number',
    Proj_Name: 'Project Name',
    Tender_Ref_No: 'Tender_Ref_No',
    RVW_No: 'RVW NO',
    RVW_Type: 'Type of RVW',
    Description: 'Description',
    Work_Description: 'Work Description',
    Reason_for_RVW: 'Reason for RVW',
    Nett_Add_Omit: 'Nett Add/(Omit)',
    Bal_of_Contingency: 'Balance of Contingency',
    Star_Rate_Items: 'Star Rate Items',
    Star_Rate_Status: 'Star Rate Status',
    Submission_Status: 'Submission Status',
    // Submission_Link: 'Submission Link',
    RVW_Submitted_by: 'RVW Submitted by (Requester)',
    Review_Status: 'Review Status',
    // Review_Link: "Review Link",
    RVW_Document_Link: 'RVW/Document Link',
    Name_First_Approval: 'Name First Approval',
    Date_First_Approval: 'Date First Approval',
    Outcome_First_Approval: 'Outcome First Approval',
    Comments_First_Approval: 'Comments First Approval',
    Name_Second_Approval: 'Name Second Approval',
    Date_Second_Approval: 'Date Second Approval',
    Outcome_Second_Approval: 'Outcome Second Approval',
    Comments_Second_Approval: 'Comments Second Approval',
    Name_Third_Approval: 'Name Third Approval',
    Date_Third_Approval: 'Date Third Approval',
    Outcome_Third_Approval: 'Outcome Third Approval',
    Comments_Third_Approval: 'Comments Third Approval',
    Name_Fourth_Approval: 'Name Fourth Approval',
    Date_Fourth_Approval: 'Date Fourth Approval',
    Outcome_Fourth_Approval: 'Outcome Fourth Approval',
    Comments_Fourth_Approval: 'Comments Fourth Approval',
    Name_Fifth_Approval: 'Name Fifth Approval',
    Date_Fifth_Approval: 'Date Fifth Approval',
    Outcome_Fifth_Approval: 'Outcome Fifth Approval',
    Comments_Fifth_Approval: 'Comments Fifth Approval',
    Remarks:'Remarks',
};


  // const options = [
  //   { value: 'selectAll', label: 'Select All' },
  //   ...columnOptions.map(column => ({
  //     value: column,
  //     label: column.replace(/_/g, ' ').toUpperCase()
  //   }))
  // ];

  const options = [
    { value: 'selectAll', label: 'Select All' },
    ...columnOptions.map(column => ({
      value: column,
      label: labelMapping[column] || column.replace(/_/g, ' ').toUpperCase()
    }))
  ];

  const handleColumnChange = (selectedOptions) => {
    if (selectedOptions.some(option => option.value === 'selectAll')) {
      if (selectedColumns.length < columnOptions.length) {
        setSelectedColumns(columnOptions); // Select all columns
      } else {
        setSelectedColumns([]); // Deselect all columns
      }
    } else {
      setSelectedColumns(selectedOptions.map(option => option.value));
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',  // Adjust width as needed
      borderColor: state.isFocused ? '#B0B0B0' : '#E0E0E0',  // Light gray border color on focus
      borderRadius: '8px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 5px rgba(176, 176, 176, 0.5)' : 'none', // Light gray focus box-shadow
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '5px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)', // Lighter shadow
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '10px',
      backgroundColor: state.isSelected ? '#B0B0B0' : state.isFocused ? '#F8F8F8' : '#fff', // Lighter gray background when selected
      color: state.isSelected ? '#fff' : '#333', // White text on selected
      borderRadius: '4px',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#B0B0B0', // Active state lighter gray background
        color: '#fff',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#B0B0B0',  // Lighter gray background for multi-value
      borderRadius: '4px',
      color: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: '#D3D3D3',  // Lighter gray color for remove icon hover
      },
    }),
  };

  const handleEditField = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  // const RVWSStatusAccountList = () => {
  //   setSubmitLoading(true);
  //   if (!submitLoading) {
  //     const sendData = rows;
  //     const requestOptions = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'ngrok-skip-browser-warning': '69420'
  //       },
  //       body: JSON.stringify(sendData),
  //     };
  //     queuedApiFetch('/project/update_rvws_status_account', requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         // alert(result.message || 'Data saved successfully');
  //         showToast.success('Data saved successfully');
  //         setSubmitLoading(false);          
  //       })
  //       .catch((error) => console.error('Error saving data:', error));
  //   }
  // };   
  
  const RVWSStatusAccountList = async () => {
    // Avoid submitting if already in progress
    if (submitLoading) return;
  
    setSubmitLoading(true);
  
    const sendData = rows;
    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(sendData),
    };
  
    try {
      const response = await queuedApiFetch(`/project/update_rvws_status_account`,
        requestOptions
      );
      const result = await response;
  
      // Check if the response status is successful
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitLoading(false); // Ensure loading state is reset after completion
    }
  };
  
  const CustomValueContainer = ({ children, ...props }) => {
    const selectedOptions = props.getValue();

    let displayValue;
    if (selectedOptions.length <= 2) {      
      displayValue = selectedOptions.map(opt => opt.label).join(', ');
    } else {      
      const displayedLabels = selectedOptions.slice(0, 2).map(opt => opt.label);
      const moreCount = selectedOptions.length - 2;
      displayValue = `${displayedLabels.join(', ')} + ${moreCount} more`;
    }

    return (
      <components.ValueContainer {...props}>
        <span>{displayValue}</span>
        {children[1]}
      </components.ValueContainer>
    );
  };
  
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();    
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };

  const handleDownloadPDF = () => {
      const element = contentRef.current;
  
      // Clone element and set wider width for full scroll capture
      const cloned = element.cloneNode(true);
      cloned.style.width = element.scrollWidth + "px";
        cloned.style.height = element.scrollHeight + "px";
  
        // Invisible container to render content without affecting layout
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "0";
    container.appendChild(cloned);
    document.body.appendChild(container);
  
      const opt = {
        margin: 0,
        filename: "RVWSStatus-Account.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 1,
          scrollX: 0,
          scrollY: 0,
          width: element.scrollWidth, // capture full scroll width
          windowWidth: element.scrollWidth,
          height: element.scrollHeight, // capture full scroll height
          windowHeight: element.scrollHeight,
        },
        jsPDF: {
          unit: "px",
          format: [element.scrollWidth, element.scrollHeight, element.offsetHeight],
          orientation: element.scrollWidth > element.scrollHeight ? "landscape" : "portrait",
          //orientation: "landscape",
        },
      };
  
      html2pdf().set(opt).from(cloned).save()
      .then(() => {
        // Clean up
        document.body.removeChild(container);
      });
  };

  const handleDownloadCSV = () => {

    const keys = Object.keys(labelMapping);
    // const csvRows = [
    //   keys.map(key => labelMapping[key]), // header row
    //   ...rows.map(row => keys.map(key => row[key] ?? '')) // data rows
    // ];

    const csvRows = [
      keys.map(key => `"${labelMapping[key]}"`), // Header row with labels
      ...rows.map(row => keys.map(key => escapeCSVValue(row[key]))) // Data rows with sanitization
    ];

    const csvContent = csvRows.map(e => e.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'RVWSStatus-Account.csv';
    link.click();

    URL.revokeObjectURL(url); // clean up
  };

  const escapeCSVValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();

    // Normalize all unicode to block obfuscation (e.g., curly quotes → straight quotes)
    str = str.normalize('NFKC');

    // Escape double quotes (RFC-compliant)
    str = str.replace(/"/g, '""');

    // Protect against formula injection
    if (/^[=+\-@]/.test(str)) {
      // Completely neutralize potential formula, don’t just prefix with `'`
      // Option 1: prefix space (safe and minimal disruption)
      str = ` ${str}`;
    }

    // Extra protection: remove known dangerous formula fragments (if any remain)
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        // Completely strip the content or replace it
        //str = '[removed for safety]';
        str = '';
        break;
      }
    }

    return `"${str}"`;
  };

  const handleDownloadXLSX = () => {
    // const keys = Object.keys(labelMapping);
    const keys = selectedColumns;
    // Build worksheet data
    const worksheetData = [
      keys.map(key => labelMapping[key]), // Header row with mapped labels
      ...rows.map(row => keys.map(key => sanitizeXLSXValue(row[key]))) // Data rows with sanitization
    ];

    // Create worksheet & workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "RVWSStatus-Account");

    // Export to file
    XLSX.writeFile(workbook, "RVWSStatus-Account.xlsx");
  };


  // Sanitize cell values for safety & consistency
  const sanitizeXLSXValue = (value) => {
    if (value == null) return '';

    let str = String(value).trim();
    str = str.normalize('NFKC'); // normalize unicode

    // Neutralize potential formula injection
    if (/^[=+\-@]/.test(str)) {
      str = ` ${str}`; // prefix with safe space
    }

    // Extra protection against dangerous keywords
    const lowerStr = str.toLowerCase();
    const dangerousKeywords = ['cmd|', '/c', 'powershell', 'shell', 'cmd.exe', 'notepad', 'calc'];
    for (const keyword of dangerousKeywords) {
      if (lowerStr.includes(keyword)) {
        str = '';
        break;
      }
    }

    return str;
  };


//     const escapeCSVValue = (value) => {
//   if (value == null) return '';

//   // Convert to string
//   let str = String(value).trim();

//   // CSV Injection prevention: Prefix with single quote if dangerous
//   if (/^[=+\-@]/.test(str)) {
//     str = `'${str}`;
//   }

//   // Escape double quotes by doubling them
//   str = str.replace(/"/g, '""');

//   // Wrap all values in double quotes
//   return `"${str}"`;
// };
  
  return (
    <div className="bodywrapp" style={{width : '100%'}}>
      {isLoading && <FullscreenLoader />} 
      <div className="header" style={{ width: '95%' }}>
        <div className="projectwrap">
          <div className="addwbswrap" style={{background: '#e7e6e6'}} >
            <button disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadXLSX}>Export Excel</button>
            <button style={{marginLeft: '30px'}} disabled={rows && rows.length == 0 ? true : false} onClick={handleDownloadPDF}>Export PDF</button>
          </div>
          <button id="submit" disabled={submitLoading || rows.length == 0 ? true : false} onClick={RVWSStatusAccountList}>Submit</button>
        </div>
      </div>

      <div id="ac_rvw_list" style={{ background: '#fff' }}>
      
      <div className="filter-wrap" style={{ width: '95%' }}>
        <Select
          isMulti
          name="columns"
          options={options}
          value={options.filter(option => selectedColumns.includes(option.value))}
          onChange={handleColumnChange}
          closeMenuOnSelect={false}
          placeholder="Select Columns"
          hideSelectedOptions={false}
          styles={customStyles}
          components={{
            ValueContainer: CustomValueContainer,
            Option: CustomOption,
          }}
        />
      </div>

        <div ref={contentRef} className="tablewrap" style={{ width: '90%', overflowX: 'auto', overflowY: 'auto', height: 'calc(100vh - 276px)' }}>
          <table id="wbsTable">
            <thead>
              <tr>
                {selectedColumns.includes('Sno') && <th className="description-column">S.No</th>}
                {selectedColumns.includes('SC_Number') && <th className="description-column">SC Number</th>}
                {selectedColumns.includes('Proj_Name') && <th className="description-column">Project Name</th>}
                {selectedColumns.includes('Tender_Ref_No') && <th className="description-column">Tender_Ref_No</th>}
                {selectedColumns.includes('RVW_No') && <th className="description-column">RVW NO</th>}
                {selectedColumns.includes('RVW_Type') && <th className="description-column">Type of RVW</th>}
                {selectedColumns.includes('Description') && <th className="description-column">Description</th>}
                {selectedColumns.includes('Work_Description') && <th className="description-column">Work Description</th>}
                {selectedColumns.includes('Reason_for_RVW') && <th className="description-column">Reason for RVW</th>}
                {selectedColumns.includes('Nett_Add_Omit') && <th className="description-column">Nett Add/(Omit)</th>}
                {selectedColumns.includes('Bal_of_Contingency') && <th className="description-column">Balance of Contingency</th>}
                {selectedColumns.includes('Star_Rate_Items') && <th className="description-column">Star Rate Items</th>}                
                {selectedColumns.includes('Star_Rate_Status') && <th className="description-column">Star Rate Status</th>} 
                {selectedColumns.includes('Submission_Status') && <th className="description-column">Submission Status</th>}                
                {/* {selectedColumns.includes('Submission_Link') && <th className="description-column">Submission Link</th>}                  */}

                {selectedColumns.includes('RVW_Submitted_by') && (
                  <th onClick={handleSort}>RVW Submitted by (Requester)&nbsp;&nbsp;{sortDirection === 'asc' ? 
                    (<FontAwesomeIcon icon={faSortUp} />) : (<FontAwesomeIcon icon={faSortDown} /> )}</th>
                )}

                {selectedColumns.includes('Review_Status') && <th className="description-column">Review Status</th>}                
                {/* {selectedColumns.includes('Review_Link') && <th className="description-column">Review Link</th>}   */}
                {selectedColumns.includes('RVW_Document_Link') && <th className="description-column">RVW/Document Link</th>} 
                {selectedColumns.includes('Name_First_Approval') && <th className="description-column">Name First Approval</th>}
                {selectedColumns.includes('Date_First_Approval') && <th style={{ minWidth: '100px' }} className="description-column">Date First Approval</th>}
                {selectedColumns.includes('Outcome_First_Approval') && <th className="description-column">Outcome First Approval</th>}
                {selectedColumns.includes('Comments_First_Approval') && <th className="description-column">Comments First Approval</th>}
                {selectedColumns.includes('Name_Second_Approval') && <th className="description-column">Name Second Approval</th>}
                {selectedColumns.includes('Date_Second_Approval') && <th style={{ minWidth: '100px' }} className="description-column">Date Second Approval</th>}
                {selectedColumns.includes('Outcome_Second_Approval') && <th className="description-column">Outcome Second Approval</th>}
                {selectedColumns.includes('Comments_Second_Approval') && <th className="description-column">Comments Second Approval</th>}
                {selectedColumns.includes('Name_Third_Approval') && <th className="description-column">Name Third Approval</th>}                
                {selectedColumns.includes('Date_Third_Approval') && <th style={{ minWidth: '100px' }} className="description-column">Date Third Approval</th>}                
                {selectedColumns.includes('Outcome_Third_Approval') && <th className="description-column">Outcome Third Approval</th>}                
                {selectedColumns.includes('Comments_Third_Approval') && <th className="description-column">Comments Third Approval</th>}

                {selectedColumns.includes('Name_Fourth_Approval') && <th className="description-column">Name Fourth Approval</th>}
                {selectedColumns.includes('Date_Fourth_Approval') && <th style={{ minWidth: '100px' }} className="description-column">Date Fourth Approval</th>}
                {selectedColumns.includes('Outcome_Fourth_Approval') && <th className="description-column">Outcome Fourth Approval</th>}
                {selectedColumns.includes('Comments_Fourth_Approval') && <th className="description-column">Comments Fourth Approval</th>}

                {selectedColumns.includes('Name_Fifth_Approval') && <th className="description-column">Name Fifth Approval</th>}
                {selectedColumns.includes('Date_Fifth_Approval') && <th style={{ minWidth: '100px' }} className="description-column">Date Fifth Approval</th>}
                {selectedColumns.includes('Outcome_Fifth_Approval') && <th className="description-column">Outcome Fifth Approval</th>}
                {selectedColumns.includes('Comments_Fifth_Approval') && <th className="description-column">Comments Fifth Approval</th>}

                {selectedColumns.includes('Remarks') && <th className="description-column">Remarks</th>}                                                                               
              </tr>
            </thead>
            <tbody>
              {selectedColumns.length === 0 ? (
                  <tr>
                    <td colSpan='38' style={{height: '100px', padding: '20px' }}>Please Select any one column</td>
                  </tr>
                )
                :
                  rows.length === 0 ? (
                    <tr>
                      <td colSpan='38' style={{height: '100px', padding: '20px' }}>{isLoading ? 'Loading...':'No records found'}</td>
                    </tr>
                  ) 
                  :
                  (
                    rows.map((row, index) => (
                      <tr key={index}>
                        {selectedColumns.includes('Sno') && <td>{index + 1}</td>}
                        {selectedColumns.includes('SC_Number') && <td>{row.SC_Number}</td>}
                        {selectedColumns.includes('Proj_Name') && <td>{row.Proj_Name}</td>}
                        {selectedColumns.includes('Tender_Ref_No') && <td>{row.Tender_Ref_No}</td>}
                        {selectedColumns.includes('RVW_No') && <td>{row.RVW_No}</td>}
                        {selectedColumns.includes('RVW_Type') && <td>{row.RVW_Type}</td>}
                        {selectedColumns.includes('Description') && <td>{row.Description}</td>}
                        {selectedColumns.includes('Work_Description') && <td>{row.Work_Description}</td>}
                        {selectedColumns.includes('Reason_for_RVW') && <td>{row.Reason_for_RVW}</td>}
                        {selectedColumns.includes('Nett_Add_Omit') && <td>{formatCurrency(row.Nett_Add_Omit)}</td>}
                        {selectedColumns.includes('Bal_of_Contingency') && <td>{formatCurrency(row.Bal_of_Contingency)}</td>}
                        {selectedColumns.includes('Star_Rate_Items') && <td>{row.Star_Rate_Items}</td>} 
                        {selectedColumns.includes('Star_Rate_Status') && (
                        <td>
                            <select
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            value={row.Star_Rate_Status}
                            onChange={(e) =>
                                handleEditField(index, 'Star_Rate_Status', e.target.value)
                            }
                            >
                              <option value="" selected>Select Star rate status</option>
                            <option value="Open">Open</option>
                            <option value="Close">Close</option>
                            </select>
                        </td>
                        )}
                        {selectedColumns.includes('Submission_Status') && <td>
                          {/* {row.Submission_Status} */}
                          <a target="_blank" href={row.Submission_Link+"?"+qs_params}>{row.Submission_Status}</a>
                          </td>}
                        {/* {selectedColumns.includes('Submission_Link') && <td>{row.Submission_Link}</td>} */}
                        {selectedColumns.includes('RVW_Submitted_by') && <td>{row.RVW_Submitted_by}</td>}
                        {selectedColumns.includes('Review_Status') && <td>
                          {/* {row.Review_Status} */}
                          <a target="_blank" href={row.Review_Link+"&"+qs_params}>{row.Review_Status}</a>
                          </td>}
                        {/* {selectedColumns.includes('Review_Link') && <td>{row.Review_Link}</td>} */}
                        {/* {selectedColumns.includes('RVW_Document_Link') && <td><a target="_blank" href={row.RVW_Document_Link}>{row.RVW_Document_Link}</a></td>}  */}
                        {selectedColumns.includes('RVW_Document_Link') && <td><a target="_blank" href={`https://acc.autodesk.com/build/files/projects/${row.Proj_Number}?folderUrn=${row.RVW_Document_Link}&viewModel=detail&moduleId=folders&${qs_params}`}>RVW Folder</a></td>} 
                        {selectedColumns.includes('Name_First_Approval') && <td>{row.Name_First_Approval}</td>}
                        {selectedColumns.includes('Date_First_Approval') && <td>{formatDate(row.Date_First_Approval)}</td>}
                        {selectedColumns.includes('Outcome_First_Approval') && <td>{row.Outcome_First_Approval}</td>}
                        {selectedColumns.includes('Comments_First_Approval') && <td>{row.Comments_First_Approval}</td>}  
                        {selectedColumns.includes('Name_Second_Approval') && <td>{row.Name_Second_Approval}</td>}  
                        {selectedColumns.includes('Date_Second_Approval') && <td>{formatDate(row.Date_Second_Approval)}</td>}  
                        {selectedColumns.includes('Outcome_Second_Approval') && <td>{row.Outcome_Second_Approval}</td>}  
                        {selectedColumns.includes('Comments_Second_Approval') && <td>{row.Comments_Second_Approval}</td>}  
                        {selectedColumns.includes('Name_Third_Approval') && <td>{row.Name_Third_Approval}</td>}  
                        {selectedColumns.includes('Date_Third_Approval') && <td>{formatDate(row.Date_Third_Approval)}</td>}  
                        {selectedColumns.includes('Outcome_Third_Approval') && <td>{row.Outcome_Third_Approval}</td>}  
                        {selectedColumns.includes('Comments_Third_Approval') && <td>{row.Comments_Third_Approval}</td>}

                        {selectedColumns.includes('Name_Fourth_Approval') && <td>{row.Name_Fourth_Approval}</td>}
                        {selectedColumns.includes('Date_Fourth_Approval') && <td>{formatDate(row.Date_Fourth_Approval)}</td>}
                        {selectedColumns.includes('Outcome_Fourth_Approval') && <td>{row.Outcome_Fourth_Approval}</td>}
                        {selectedColumns.includes('Comments_Fourth_Approval') && <td>{row.Comments_Fourth_Approval}</td>}

                        {selectedColumns.includes('Name_Fifth_Approval') && <td>{row.Name_Fifth_Approval}</td>}
                        {selectedColumns.includes('Date_Fifth_Approval') && <td>{formatDate(row.Date_Fifth_Approval)}</td>}
                        {selectedColumns.includes('Outcome_Fifth_Approval') && <td>{row.Outcome_Fifth_Approval}</td>}
                        {selectedColumns.includes('Comments_Fifth_Approval') && <td>{row.Comments_Fifth_Approval}</td>}    

                        {selectedColumns.includes('Remarks') && <td> 
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Remarks}
                            onChange={(e) =>
                              handleEditField(index, 'Remarks', e.target.value)
                            }
                          />
                        </td>}                    
                      </tr>
                    ))
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default RVWSStatus;
